<template>
  <v-menu location="bottom start">
    <template #activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        variant="flat"
        color="surface-light"
        class="border text-none flex-shrink-0 text-no-wrap"
        rounded="lg"
        size="small"
        append-icon="$dropdown"
      >
        <template #prepend>
          <v-icon
            :icon="currentSpaceConfig.icon"
            color="secondary"
            size="small"
          />
        </template>
        {{ currentSpaceInfo ? getSpaceLabel(currentSpaceInfo) : '' }}
      </v-btn>
    </template>
    <v-list nav density="compact">
      <v-list-item
        v-for="space in spaces"
        :key="space.key"
        :prepend-icon="SPACE_CONFIG[space.key].icon"
        :title="getSpaceLabel(space)"
        :active="space.key === currentSpace"
        :to="getSpaceSwitchPath(space.key)"
        class="pl-3"
        slim
      />
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { SPACE_CONFIG } from '@/constants/spaces'
import { useCurrentSpace, useSpaces } from '@/composables/use-spaces'

const { spaces } = useSpaces()
const {
  currentSpace,
  currentSpaceConfig,
  currentSpaceInfo,
  getSpaceLabel,
  getSpaceSwitchPath,
} = useCurrentSpace()
</script>
